<app-elevation-section [title]="customTitle" [initialHeight]="true"[removePadding]="true">
  <dx-data-grid #datagriddx
    [height]="height"
    [dataSource]="gridWithSummaryDataSource"
    [rowAlternationEnabled]="true"
    [columnAutoWidth]="true"
    [showBorders]="true"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onCellPrepared)="onCellPrepared($event)"
    noDataText="Velg en linje i timegriden for å se ukevisning">

    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-editing mode="row" [allowUpdating]="false" [allowAdding]="false" [useIcons]="true"></dxo-editing>

    <dxi-column dataField="TimeTypeCategoryCode" caption="" [width]="widthTimeTypeCategory"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmMonday" caption="{{languageService.LNG('Label.Monday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmTuesday" caption="{{languageService.LNG('Label.Tuesday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmWednesday" caption="{{languageService.LNG('Label.Wednesday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmThursday" caption="{{languageService.LNG('Label.Thursday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmFriday" caption="{{languageService.LNG('Label.Friday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmSaturday" caption="{{languageService.LNG('Label.Saturday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmSunday" caption="{{languageService.LNG('Label.Sunday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmTotal" caption="{{languageService.LNG('Label.Sum')}}" alignment="right"></dxi-column>
    
    <div *dxTemplate="let data of 'headerTitle'">
      <span *ngIf="showTitle" style="font-size: 20px;" >{{this.headerTitle}}</span>
    </div>

    <dxo-summary [calculateCustomSummary]="calculateSummary">
        <dxi-total-item
            name="SumMonday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmMonday">
        </dxi-total-item>
        <dxi-total-item
            name="SumTuesday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmTuesday">
        </dxi-total-item>
        <dxi-total-item
            name="SumWednesday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmWednesday">
        </dxi-total-item>
        <dxi-total-item
            name="SumThursday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmThursday">
        </dxi-total-item>
        <dxi-total-item
            name="SumFriday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmFriday">
        </dxi-total-item>
        <dxi-total-item
            name="SumSaturday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmSaturday">
        </dxi-total-item>
        <dxi-total-item
            name="SumSunday"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmSunday">
        </dxi-total-item>
        <dxi-total-item
            name="SumTotal"
            summaryType="custom"
            displayFormat="{0}"
            showInColumn="TotSecondsToHHmmTotal">
        </dxi-total-item>
    </dxo-summary>
  </dx-data-grid>

  <dx-data-grid
    [height]="40"
    [showColumnHeaders]="false"
    [dataSource]="gridWithoutSummaryDataSource"
    [rowAlternationEnabled]="true"
    [columnAutoWidth]="false"
    [showBorders]="true"    
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onCellPrepared)="onCellPrepared($event)"
    noDataText=" ">

    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-editing mode="row" [allowUpdating]="false" [allowAdding]="false" [useIcons]="true"></dxo-editing>

    <dxi-column dataField="TimeTypeCategoryCode" caption="" [width]="widthTimeTypeCategory"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmMonday" caption="{{languageService.LNG('Label.Monday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmTuesday" caption="{{languageService.LNG('Label.Tuesday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmWednesday" caption="{{languageService.LNG('Label.Wednesday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmThursday" caption="{{languageService.LNG('Label.Thursday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmFriday" caption="{{languageService.LNG('Label.Friday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmSaturday" caption="{{languageService.LNG('Label.Saturday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmSunday" caption="{{languageService.LNG('Label.Sunday_Short')}}" alignment="right" [width]="weekDayColumnWidth"></dxi-column>
    <dxi-column dataField="TotSecondsToHHmmTotal" caption="{{languageService.LNG('Label.Sum')}}" alignment="right"></dxi-column>
  </dx-data-grid>
</app-elevation-section>
